import { ListSearchParams, PaginatedResponse } from './List'
import { Tenant } from './Tenant'

export interface Project {
    id: string
    name: string
    orientation: ProjectOrientation
    type: ProjectType
    description?: string
    domain?: string
    status: ProjectStatus
    with_web_target?: boolean
    content?: ProjectContent
    qr_url?: string
    views?: number
    redirect_slug?: string
    redirect_url?: string
    created_at: Date
}

export interface ProjectRedirect {
    slug: string
    destinationUrl: string
    redirectUrl: string
    active: boolean
}

export interface ProjectRedirectUpdateRequest {
    destinationUrl?: string
    active?: boolean
}

export interface Projects extends PaginatedResponse<Project> {
    tenant?: Tenant
}

export interface ProjectListParams extends ListSearchParams {}

export interface ProjectGetParams {}

export interface ProjectRequest {
    id: string
    tenant_id?: string
    name: string
    orientation: ProjectOrientation
    description?: string
    domain?: string
    stage_data: ProjectStageDataRequest
    with_web_target?: boolean
}

export interface ProjectStageDataRequest {
    image_targets: ImageTarget[]
    splash?: ProjectSplash
    banner?: ProjectBanner
    mind: string
}

export interface ImageTarget {
    image: string
    width: number
    height: number
    video: string
    image2?: string
    width2?: number
    height2?: number
    video2?: string
    button?: ImageTargetButton
}

export interface ImageTargetButton {
    text: string
    url: string
    image: string
    timing?: string
}

export type ProjectContent = {
    [key in ProjectStage]: ProjectStageData
}

export interface ProjectStageData {
    mind: string
    splash: ProjectSplash
    banner: ProjectBanner
    image_targets: ImageTarget[]
}

export interface ProjectSplash {
    logo: string
    logo_position: string
    logo_size: string
    background: string
}

export interface ProjectBanner {
    title: string
    subtitle?: string
    image: string
}

export interface ProjectPreview extends ProjectStageData {}

export type ProjectStatus = 'NEW' | 'AVAILABLE' | 'DELETED'

export type ProjectStage = 'dev' | 'prod'

export type ProjectOrientation = 'LANDSCAPE' | 'PORTRAIT'

export type ProjectType = 'LIVING_PORTRAIT' | 'POSTCARD'

export const PROJECT_STATUSES: ProjectStatus[] = ['NEW', 'AVAILABLE', 'DELETED']

export const PROJECT_ORIENTATIONS: ProjectOrientation[] = [
    'LANDSCAPE',
    'PORTRAIT',
]

export const PROJECT_TYPES: ProjectType[] = ['LIVING_PORTRAIT', 'POSTCARD']

export const isEqualsImageTarget = (
    current: ImageTarget,
    request: ImageTarget
) => {
    return (
        current.image === request.image &&
        current.video === request.video &&
        current.width === request.width &&
        current.height === request.height
    )
}

export const isEquals = (current: ImageTarget[], request: ImageTarget[]) => {
    if (current.length !== request.length) {
        return false
    }

    for (const imageTarget of current) {
        const requestImageTarget = request.find(
            (el) => el.image === imageTarget.image
        )
        if (
            !requestImageTarget ||
            !isEqualsImageTarget(imageTarget, requestImageTarget)
        ) {
            return false
        }
    }

    return true
}
